import Link from 'next/link';
import React from 'react';
import styles from './energy.module.scss';
import PageHeaderComponent from '../util/PageHeader/PageHeaderComponent';
import DefaultWidthContainer from '../Layout/Containers/DefaultWidthContainer';
import FullWidthContainer from '../Layout/Containers/FullWidthContainer';
import ExpandingCardsComponent from '../ExpandingCards/ExpandingCardsComponent';
import CustomerFeedbackComponent from '../CustomerFeedback/CustomerFeedbackComponent';
import LargeWidthContainer from '../Layout/Containers/LargeWidthContainer';
import ConsultantContactComponent from '../Contact/ConsultantContactComponent';

const EnergyComponent = () => (
    <>
        <FullWidthContainer extraClassNames={styles.pageHeaderBackground}>
            <div className={styles.headerBackground} aria-hidden="true"></div>
            <PageHeaderComponent
                heading="Energy &amp; Offshore"
                quote="We strengthen your IT organisation with experienced consultants in architecture, development, project leadership and quality assurance. Our people connect technical decisions with business needs and take responsibility for critical parts of your delivery."
            >
                <h1 className={styles.heading}>
                    <span className={styles.desktopOnly}>Senior </span>IT consultants for <br />
                    <span>energy and offshore</span>
                </h1>
            </PageHeaderComponent>
            <DefaultWidthContainer extraClassNames={styles.linksContainer}>
                <div className={styles.links}>
                    <Link href="#contact" className="nv-buton nv-button-primary">
                        <span>Talk to Hilda</span>
                        <span aria-hidden="true">&#10132;</span>
                    </Link>
                    <Link href="#help" className="nv-buton nv-button-secondary">
                        <span>See how we can help</span>
                        <span aria-hidden="true">&#10132;</span>
                    </Link>
                </div>
            </DefaultWidthContainer>
        </FullWidthContainer>

        <ExpandingCardsComponent id="help" />

        <CustomerFeedbackComponent />

        <LargeWidthContainer
            extraClassNames={styles.doubleColumnContainer}
            extraStyles={{
                paddingTop: 115,
                paddingBottom: 115,
                borderBottom: '1px solid rgba(37, 36, 35, 0.12)',
            }}
        >
            <div className={styles.doubleColumn}>
                <div className={styles.child}>
                    <span className={styles.whyNoriaEyebrow}>Why Noria</span>
                    <h2 className={styles.whyNoriaHeading}>
                        Technical expertise. Business understanding.
                    </h2>
                </div>
                <div className={styles.child}>
                    <p>
                        Our experience with business-critical systems in banking and finance
                        provides a strong foundation in complex integrations, quality and delivery.
                        We are building on that foundation in energy and offshore, recruiting people
                        with relevant sector experience and sharing knowledge across our teams.
                    </p>
                    <p>
                        Your context comes first. Our consultants work alongside your people, learn
                        how your business operates and take responsibility for agreed areas of work.
                    </p>
                </div>
            </div>
        </LargeWidthContainer>

        <LargeWidthContainer
            extraClassNames={styles.doubleColumnContainer}
            extraStyles={{ paddingTop: 115, paddingBottom: 115 }}
        >
            <div className={styles.doubleColumn}>
                <div className={styles.child}>
                    <h2 className={styles.faqHeading}>A few practical questions</h2>
                </div>
                <div className={styles.child}>
                    <div className={styles.faqList}>
                        <details className={styles.faqItem} open>
                            <summary>How do your consultants work with our team?</summary>
                            <p>
                                They join your team on agreed terms — working in your tools, rituals
                                and codebase — and take ownership of clearly defined areas of work.
                            </p>
                        </details>
                        <details className={styles.faqItem}>
                            <summary>
                                Can we discuss AI or automation before defining a project?
                            </summary>
                            <p>
                                Yes. We often start with a short conversation about the process,
                                data and constraints, then suggest practical next steps.
                            </p>
                        </details>
                        <details className={styles.faqItem}>
                            <summary>What happens when I contact you?</summary>
                            <p>
                                Hilda will get in touch to understand your situation and suggest who
                                from Noria is best placed to help.
                            </p>
                        </details>
                    </div>
                </div>
            </div>
        </LargeWidthContainer>

        <ConsultantContactComponent />
    </>
);

export default EnergyComponent;
